import { render, staticRenderFns } from "./UserItemInfoIcons.vue?vue&type=template&id=544fe018&scoped=true"
import script from "./UserItemInfoIcons.vue?vue&type=script&lang=ts"
export * from "./UserItemInfoIcons.vue?vue&type=script&lang=ts"
import style0 from "./UserItemInfoIcons.vue?vue&type=style&index=0&id=544fe018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544fe018",
  null
  
)

export default component.exports